<template>
  <main>
    <Loading v-if="isLoading"></Loading>

     <!-- Halt for End of day Modal -->
    <div
      v-if="showHaltForEndOfDayModel"
      id="showHaltForEndOfDayOverlay"
      class="fixed z-50 inset-0 bg-black bg-opacity-50 flex items-center justify-center"
    >
      <div class="">
        <div class="flex relative items-center justify-center bg-gray-100">
          <div class="w-full max-w-lg px-6 py-9 bg-white rounded-lg shadow-lg">
            <button
              class="absolute top-0 right-0 mt-2 mr-2 text-gray-500 hover:text-gray-700"
              @click="showHaltForEndOfDayModel = false"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            <!-- <div class="flex justify-center mb-4">
              <div
                class="w-16 h-16 flex items-center justify-center bg-red-100 rounded-full"
              >
                <svg
                  class="w-8 h-8 text-red-500"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M6 18L18 6M6 6l12 12" />
                </svg>
              </div>
            </div> -->
            <h2
              class="text-center mx-auto w-2/3 text-xl font-semibold text-gray-900 mb-2"
            >
              ERROR
            </h2>
            <p class="text-center text-sm my-2">Sorry you can’t set a fixed deduction amount for End of the day settlement merchants</p>
            <div class="flex w-1/3 mx-auto space-x-4">
              <button
                @click="showHaltForEndOfDayModel = false"
                class="uppercase flex-1 bg-blue-800 flex shadow m-2 text-white focus:shadow-outline focus:outline-none text-xs font-bold py-3 px-3 rounded"
              >
                <div class="text-xs text-center w-full">Okay</div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Halt for End of day Modal -->

    <!-- Template Preview Modal -->
    <div
      v-if="showValidatedTemplate"
      id="templatePreview"
      class="fixed z-50 inset-0 bg-black bg-opacity-50 flex items-center justify-center"
    >
      <div
        class="w-full relative max-w-5xl px-6 py-9 bg-white rounded-lg shadow-lg"
      >
        <button
          class="absolute top-0 right-0 text-sm mt-2 mr-2 text-gray-500 hover:text-gray-700"
          @click="resetTemplateData()"
        >
          close
        </button>
        <h1 class="text-lg font-bold">Uploaded Document Preview</h1>
        <h2 class="text-sm">Review the details below</h2>
        <div
          v-if="templateErrorMessage"
          class="mt-6 w-full lg:w-1/2 border bg-red-100 px-4 py-3 rounded-md text-sm font-medium"
        >
          {{ templateErrorMessage }}
        </div>
        <div
          class="overflow-auto border border-default px-3 rounded mt-3"
          style="max-height: 400px"
        >
          <table
            id="template-preview-table"
            class="my-4 bg-white w-full text-xs relative border-default"
          >
            <thead>
              <tr class="border-b-default border-gray-100">
                <th class="border whitespace-nowrap text-left px-2 py-2">#</th>
                <th class="border whitespace-nowrap text-left px-2 py-2">
                  Amount
                </th>
                <th class="border whitespace-nowrap text-left px-2 py-2">
                  Business Email
                </th>
                <th class="border whitespace-nowrap text-left px-2 py-2">
                  Day of Week
                </th>
                <th class="border whitespace-nowrap text-left px-2 py-2">
                  Frequency
                </th>
                <th class="border whitespace-nowrap text-left px-2 py-2">
                  Loan Disk ID
                </th>
                <th class="border whitespace-nowrap text-left px-2 py-2">
                  Deduction Method
                </th>
                <th class="border whitespace-nowrap text-left px-2 py-2">
                  Start At
                </th>
                <th class="border whitespace-nowrap text-left px-2 py-2">
                  Total Amount
                </th>
                <th class="border whitespace-nowrap text-left px-2 py-2">
                  Type
                </th>
                <!-- <th class="border whitespace-nowrap text-left px-2 py-2">
                  Error Message
                </th> -->
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(record, index) in templateData"
                :key="index"
                class="hover:bg-gray-100 bg-gray-50 cursor-pointer"
              >
                <td class="border p-2">{{ index + 1 }}</td>
                <td class="border p-2">{{ record.amount }}</td>
                <td class="border p-2">{{ record.businessEmail }}</td>
                <td class="border p-2">{{ record.dayOfWeek }}</td>
                <td class="border p-2">{{ record.frequency }}</td>
                <td class="border p-2">{{ record.loanDiskId }}</td>
                <td class="border p-2 capitalize">{{ record.deductionMethod }}</td>
                <td class="border p-2">{{ record.startAt }}</td>
                <td class="border p-2">{{ record.totalAmount }}</td>
                <td class="border p-2">{{ record.type }}</td>
                <!-- <td class="border p-2">{{ record.errorMessage }}</td> -->
              </tr>
            </tbody>
          </table>
        </div>
        <div class="flex justify-end">
          <button
            id="submit-template"
            :disabled="shouldSendTemplate"
            :class="{ 'opacity-50': shouldSendTemplate }"
            class="bg-blue-800 my-2 flex shadow text-white focus:shadow-outline focus:outline-none text-xs font-normal py-3 px-6 rounded"
            @click="submitTemplate"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
    <!-- End Template Preview Modal -->

    <!-- Success Modal -->
    <div
      v-if="csvUploadSuccessful"
      id="successModal"
      class="fixed z-50 inset-0 bg-black bg-opacity-50 flex items-center justify-center"
    >
      <div
        class="w-full relative max-w-lg px-6 py-9 bg-white rounded-lg shadow-lg"
      >
        <button
          class="absolute top-0 right-0 text-sm mt-2 mr-2 text-gray-500 hover:text-gray-700"
          @click="resetTemplateData"
        >
          close
        </button>
        <div class="flex justify-center mb-4">
          <div
            class="w-16 h-16 flex items-center justify-center bg-green-100 rounded-full"
          >
            <svg
              class="w-8 h-8 text-green-500"
              fill="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 19c-.25 0-.49-.1-.68-.29l-5-5a1.003 1.003 0 011.42-1.42L9 16.59l8.29-8.3a1.003 1.003 0 011.42 1.42l-9 9a1.003 1.003 0 01-.71.29z"
              ></path>
            </svg>
          </div>
        </div>
        <h2
          class="text-center mx-auto w-2/3 text-xl font-semibold text-gray-900 mb-2"
        >
          You have successfully uploaded the CSV File
        </h2>
      </div>
    </div>
    <!-- End Success Modal -->

    <div>
      <div>
        <button class="text-xs" @click="$router.go(-1)">&lt; Go Back</button>
        <h1 class="text-2xl font-bold">Auto Deduction Settings</h1>
        <div v-if="!editOrAdd" class="flex mt-12 gap-x-2 items-center">
          <div class="flex-1"></div>
          <button
            @click="downloadDeductionCSVTemplate()"
            class="bg-blue-800 flex shadow m-2 text-white focus:shadow-outline focus:outline-none text-xs font-normal py-3 px-3 rounded"
          >
            <span class="flex-1 px-4">Download CSV Template</span>
          </button>
          <button
            class="bg-green-800 flex shadow m-2 text-white focus:shadow-outline focus:outline-none text-xs font-normal py-3 px-3 rounded"
            @click="triggerFileUpload"
          >
            <span class="flex-1 px-4">Upload CSV</span>
          </button>
          <input
            type="file"
            ref="fileInput"
            accept=".csv"
            style="display: none"
            @change="handleFileUpload"
          />
        </div>
        <div v-else class="my-8 text-white">.</div>
        <div
          v-if="responseMessage"
          class="mt-6 w-full lg:w-1/2 border border-green-300 bg-red-100 px-4 py-3 rounded-md text-sm font-medium"
        >
          {{ responseMessage }}
        </div>
        <div class="mt-4 w-full lg:w-1/2 border-default rounded px-4 py-3">
          <p class="text-xs font-medium my-3">Enter Details below</p>
          <div class="grid grid-cols-2 gap-4">
            <div class="col-span-1">
              <label class="text-xs font-bold text-gray-400"
                >Select Deduction Type?
                <span v-if="!formValid.deductionType" class="text-red-600"
                  >*</span
                >
              </label>
              <select
                v-model="formDetails.deductionType"
                class="form-input border-opacity-25 border-black"
              >
                <option value="" disabled selected>Select an Option</option>
                <option value="saving">Savings Deduction</option>
                <option value="loan">Loan Repayment</option>
                <option value="lease">Terminal Lease Payments</option>
              </select>
            </div>
            <div class="col-span-1">
              <label class="text-xs font-bold text-gray-400"
                >Deduction Amount or Percentage
                <span v-if="!formValid.deductionAmount" class="text-red-600"
                  >*</span
                >
              </label>
              <div
                class="flex bg-white gap-x-1 flex-row w-full rounded px-2 py-2 text-xs border-default border-opacity-25 border-black"
              >
                <input
                  v-model="formDetails.deductionAmount"
                  placeholder="Enter details here"
                  type="number"
                  class="flex-1 bg-transparent"
                />
                <button
                  class="px-2 py-1 rounded-md border-default"
                  :class="numberOrPercentage ? 'bg-blue-400 text-white' : ''"
                  @click="toggleNumberOrPercentage(true)"
                >
                  ₦
                </button>
                <button
                  class="px-2 py-1 rounded-md border-default"
                  :class="!numberOrPercentage ? 'bg-blue-400 text-white' : ''"
                  @click="toggleNumberOrPercentage(false)"
                >
                  %
                </button>
              </div>
            </div>
            <div v-if="numberOrPercentage" id="deductionMethodSection" class="col-span-2">
              <div class="text-xs font-bold text-gray-400">
                Deduction Method
                <span v-if="!formValid.deductionMethod" class="text-red-600">*</span>
              </div>
              <div class="flex flex-col gap-y-1 text-xs mt-2">
                <label class="flex items-center gap-x-1 gap-y-2">
                  <input type="radio" value="forced" v-model="deductionMethod" />
                  <b>Forced</b> - deduct less than or equal to fixed amount
                </label>
                <label class="flex items-center gap-x-1 gap-y-2">
                  <input type="radio" value="optional" v-model="deductionMethod" />
                  <b>Optional</b> - don’t deduct if the transaction amount is less than fixed amount
                </label>
              </div>
            </div>
            <div v-if="showIfLoan || showIfLease" class="col-span-1">
              <label class="text-xs font-bold text-gray-400"
                >Total Payment Amount
                <span v-if="!formValid.totalAmount" class="text-red-600"
                  >*</span
                >
              </label>
              <input
                v-model="formDetails.totalAmount"
                placeholder="Enter details here"
                type="number"
                class="form-input border-opacity-25 border-black"
              />
            </div>
            <div v-if="showIfLoan || showIfSavings" class="col-span-1">
              <label class="text-xs font-bold text-gray-400"
                >Loandisk ID
                <span v-if="!formValid.loadiskID" class="text-red-600">*</span>
              </label>
              <input
                v-model="formDetails.loadiskID"
                placeholder="Enter Loandisk Savings Account Number or Loan #"
                type="text"
                class="form-input border-opacity-25 border-black"
              />
            </div>
            <div v-if="numberOrPercentage" class="col-span-1">
              <label class="text-xs font-bold text-gray-400"
                >Deduction Frequency?
                <span v-if="!formValid.deductionFrequency" class="text-red-600"
                  >*</span
                >
              </label>
              <select
                v-model="formDetails.deductionFrequency"
                class="form-input border-opacity-25 border-black"
              >
                <option value="" disabled selected>Select an Option</option>
                <option value="daily">Daily</option>
                <option value="weekly">Weekly</option>
              </select>
            </div>
            <div
              v-if="formDetails.deductionFrequency === 'weekly'"
              class="col-span-1"
            >
              <label class="text-xs font-bold text-gray-400"
                >Deduction Day
                <span v-if="!formValid.deductionDay" class="text-red-600"
                  >*</span
                >
              </label>
              <select
                v-model="formDetails.deductionDay"
                class="form-input border-opacity-25 border-black"
              >
                <option value="" disabled selected>Select a Day</option>
                <option value="MON">Monday</option>
                <option value="TUE">Tuesday</option>
                <option value="WED">Wednesday</option>
                <option value="THU">Thursday</option>
                <option value="FRI">Friday</option>
                <option value="SAT">Saturday</option>
                <option value="SUN">Sunday</option>
              </select>
            </div>
            <div class="col-span-1">
              <label class="text-xs font-bold text-gray-400"
                >Deduction Start Date
                <span v-if="!formValid.deductionStartDate" class="text-red-600"
                  >*</span
                >
              </label>
              <date-picker
                v-model="formDetails.deductionStartDate"
                format="YYYY-MM-DD"
                :disabled-date="
                  (date) => date <= moment().subtract(1, 'days').toDate()
                "
                type="date"
                valueType="format"
              ></date-picker>
            </div>
            <div class="col-span-1">
              <label class="text-xs font-bold text-gray-400"
                >Merchant Email?
                <span v-if="!formValid.merchantEmail" class="text-red-600"
                  >*</span
                >
              </label>
              <div
                class="flex bg-white flex-row w-full rounded px-2 py-2 text-xs border-default border-opacity-25 border-black"
              >
                <input
                  v-model="formDetails.merchantEmail"
                  placeholder="Enter details here"
                  type="text"
                  class="flex-1 bg-transparent"
                  @keyup.enter="checkBeforeMerchantSearch()"
                />
                <button
                  :disabled="!allowMerchantSearch"
                  :class="{ 'opacity-50': !allowMerchantSearch }"
                  class="bg-blue-500 text-white px-4 py-2 rounded"
                  @click="searchMerchantList"
                >
                  Search
                </button>
              </div>
            </div>
            <div
              id="merchant-list-section"
              v-if="merchantList.length > 0"
              class="col-span-2"
            >
              <table
                class="mt-6 mb-3 bg-white w-full text-xs relative border-default"
              >
                <tr>
                  <th
                    colspan="2"
                    class="border whitespace-nowrap text-left px-2 py-2"
                  >
                    Business Name
                  </th>
                  <th
                    colspan="2"
                    class="border whitespace-nowrap text-left px-2 py-2"
                  >
                    Business Address
                  </th>
                </tr>
                <tr
                  class="row-bg cursor-pointer"
                  v-for="(merchant, index) in merchantList"
                  :key="index"
                >
                  <td colspan="2" class="border p-2">
                    {{ merchant.business_name }}
                  </td>
                  <td colspan="2" class="border p-2">
                    {{ merchant.business_address }}
                  </td>
                  <td class="border p-2 flex justify-end">
                    <button
                      class="bg-blue-800 flex shadow text-white focus:shadow-outline focus:outline-none text-xs font-normal py-3 px-6 rounded"
                      @click="selectMerchant(merchant)"
                    >
                      Add Merchant
                    </button>
                  </td>
                </tr>
              </table>
            </div>
            <div
              v-if="selectedMerchants.length > 0"
              class="col-span-2 border border-default"
            >
              <div
                class="row-bg-2 text-xs font-bold border whitespace-nowrap text-left px-2 py-2"
              >
                Selected Merchants
              </div>
              <div class="p-2 text-xs flex gap-x-2 row-bg-3">
                <div
                  class="merchant-pill border"
                  v-for="(merchant, index) in selectedMerchants"
                  :key="index"
                >
                  <span class="flex-1 whitespace-nowrap">{{
                    merchant.business_name
                  }}</span>
                  <button class="text-red-500" @click="removeMerchant(index)">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-4 w-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-span-2 gap-x-2 flex justify-end">
              <button
                @click="$router.go(-1)"
                class="flex border-default border-gray-400 text-xs font-normal py-3 px-6 rounded"
              >
                Cancel
              </button>
              <button
                class="bg-blue-800 flex shadow text-white focus:shadow-outline focus:outline-none text-xs font-normal py-3 px-6 rounded"
                :class="{ 'opacity-50': !enabledToSubmit }"
                :disabled="!enabledToSubmit"
                @click="checkBeforeProcess()"
              >
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="border p-12 rounded-lg mx-12 mt-12">
        <h3 class="text-2xl mb-2 font-bold">Error Occured</h3>
        <p>
          error
        </p>
        <button class="uppercase flex shadow my-2 bg-blue-900 text-white focus:shadow-outline focus:outline-none text-xs font-bold py-3 px-3 rounded">
          Clear
        </button>
      </div> -->
    </div>
  </main>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import { json2excel } from "js2excel";
import Loading from "./general-components/Loading.vue";
export default {
  data() {
    return {
      showHaltForEndOfDayModel: false,
      isLoading: false,
      moment,
      dateData: null,
      dateRange: [],
      formDetails: {
        deductionType: "",
        deductionAmount: "",
        totalAmount: "0",
        deductionFrequency: "",
        deductionStartDate: "",
        merchantEmail: "",
        deductionDay: "",
        loadiskID: "",
        merchantDetails: {
          settlement_type: "",
          business_id: "",
          business_name: "",
          email: "",
        },
      },
      numberOrPercentage: true,
      merchantList: [],
      selectedMerchants: [],
      responseMessage: "",
      successMessage: "",
      showValidatedTemplate: false,
      templateData: [],
      csvUploadSuccessful: false,
      templateBase64: "",
      editOrAdd: !!this.$route.params._id,
      deductionMethod: '',
    };
  },
  computed: {
    blockIfSameDayAndFixedAmount() {
      const isSameDay = this.selectedMerchants.length > 1
        ? this.selectedMerchants.every((merchant) => merchant.settlement_type === "sameday")
        : this.selectedMerchants[0].settlement_type === "sameday";
        return isSameDay && this.numberOrPercentage === true
    },
    allowMerchantSearch() {
      return this.formValid.merchantEmail;
    },
    sameDeductionMultipleMerchantPayload() {
      return this.selectedMerchants.map((merchant) => {
        return {
          ...this.deductionPayload,
          businessName: merchant.business_name,
          businessId: merchant.business_id,
          businessEmail: merchant.email,
        };
      });
    },
    shouldSendTemplate() {
      return !!this.templateErrorMessage;
    },
    templateErrorMessage() {
      return this.templateData
        .filter((record) => record.errorMessage)
        .map((record) => record.errorMessage)
        .join(", ");
    },
    formValid() {
      return {
        deductionType: !!this.formDetails.deductionType,
        deductionAmount:
          !!this.formDetails.deductionAmount &&
          !isNaN(this.formDetails.deductionAmount) &&
          this.formDetails.deductionAmount > 0 &&
          (this.numberOrPercentage || this.formDetails.deductionAmount <= 100),
        totalAmount:
          this.formDetails.deductionType === "saving" ||
          (!!this.formDetails.totalAmount &&
            !isNaN(this.formDetails.totalAmount) &&
            this.formDetails.totalAmount > 0),
        deductionFrequency: this.numberOrPercentage ? !!this.formDetails.deductionFrequency : true,
        deductionStartDate: !!this.formDetails.deductionStartDate,
        merchantEmail:
          !!(this.formDetails.merchantEmail || "").trim() &&
          /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
            (this.formDetails.merchantEmail || "").trim()
          ),
        deductionDay:
          this.numberOrPercentage === false || this.formDetails.deductionFrequency !== "weekly"
            ? true
            : !!this.formDetails.deductionDay,
        loadiskID: true, // Make loadiskID optional
        merchantDetails:
          this.sameDeductionMultipleMerchantPayload.length > 1
            ? true
            : !!this.formDetails.merchantDetails.business_id &&
              !!this.formDetails.merchantDetails.business_name,
        deductionMethod: this.numberOrPercentage ? !!this.deductionMethod : true,
      };
    },
    showIfSavings() {
      return this.formDetails.deductionType === "saving";
    },
    showIfLoan() {
      return this.formDetails.deductionType === "loan";
    },
    showIfLease() {
      return this.formDetails.deductionType === "lease";
    },
    deductionPayload() {
      return {
        loanDiskId: this.formDetails.loadiskID,
        businessId: this.formDetails.merchantDetails.business_id,
        businessName: this.formDetails.merchantDetails.business_name,
        settlementType: this.formDetails.merchantDetails.settlement_type,
        businessEmail: this.formDetails.merchantEmail,
        amount: this.numberOrPercentage
          ? `${Number(this.formDetails.deductionAmount)}`
          : `${this.formDetails.deductionAmount}%`,
        type: this.formDetails.deductionType,
        ...(this.numberOrPercentage ? { frequency: this.formDetails.deductionFrequency } : {}),
        ...(this.numberOrPercentage ? { dayOfWeek: this.formDetails.deductionDay } : {}),
        status: "pending",
        totalAmount: Number(this.formDetails.totalAmount),
        startAt: this.formDetails.deductionStartDate,
        ...(this.numberOrPercentage && { deductionMethod: this.deductionMethod }),
      };
    },
    updateDeductionPayload() {
      return {
        loanDiskId: this.formDetails.loadiskID,
        amount: this.numberOrPercentage
          ? `${this.formDetails.deductionAmount}`
          : `${this.formDetails.deductionAmount}%`,
        type: this.formDetails.deductionType,
        ...(this.numberOrPercentage ? { frequency: this.formDetails.deductionFrequency } : {}),
        ...(this.numberOrPercentage ? { dayOfWeek: this.formDetails.deductionDay } : {}),
        status: "pending",
        totalAmount: this.formDetails.totalAmount,
        startAt: this.formDetails.deductionStartDate,
        ...(this.numberOrPercentage && { deductionMethod: this.deductionMethod }),
      }
    },
    enabledToSubmit() {
      return Object.values(this.formValid).every(Boolean);
    },
  },
  methods: {
    checkBeforeProcess() {
      if(this.blockIfSameDayAndFixedAmount) {
        this.showHaltForEndOfDayModel = true;
        return;
      }
      else {
        this.editOrAdd ? this.updateDeduction() : this.submitDeduction()
      }
    },
    checkBeforeMerchantSearch() {
      if (this.allowMerchantSearch) {
        this.searchMerchantList();
      } else {
        return;
      }
    },
    toggleNumberOrPercentage() {
      this.numberOrPercentage = !this.numberOrPercentage;
    },
    downloadDeductionCSVTemplate() {
      this.$store
        .dispatch("AUTO_DEDUCTION_TEMPLATE_CSV")
        .then((response) => {
          const link = document.createElement("a");
          link.href = response.data.link;
          link.download = "deduction_template.csv";
          link.click();
        })
        .catch((error) => {
          console.error("Error downloading CSV template:", error);
        });
    },
    triggerFileUpload() {
      this.$refs.fileInput.click();
    },
    handleFileUpload(event) {
      this.responseMessage = "";
      const file = event.target.files[0];
      if (file && file.type === "text/csv") {
        const reader = new FileReader();
        reader.onload = (e) => {
          const base64 = e.target.result.toString().replace(/^data:(.*,)?/, "");
          this.templateBase64 = base64;
          this.isLoading = true;
          this.$store
            .dispatch("TEMPLATE_VALIDATE", { records: base64 })
            .then((response) => {
              if (response.status) {
                this.showValidatedTemplate = true;
                this.templateData = response.data.records;
              } else {
                console.error("Template validation failed:", response.message);
              }
              this.isLoading = false;
            })
            .catch((error) => {
              console.error("Error validating template:", error);
              this.isLoading = false;
            });
        };
        reader.readAsDataURL(file);
      } else {
        console.error("Please select a valid CSV file.");
        this.responseMessage = "Please select a valid CSV file.";
      }
    },
    searchMerchantList() {
      this.isLoading = true;
      this.$store
        .dispatch("SEARCH_MERCHANT_BY_NAME", {
          email: this.formDetails.merchantEmail,
        })
        .then((result) => {
          // debugger;
          if (result.status) {
            console.log(result);
            this.merchantList = result.data.items;
            this.isLoading = false;
          } else if (!result.success) {
            this.responseMessage = result.error;
            this.isLoading = false;
          } else {
            this.responseMessage = result.error;
            this.isLoading = false;
          }
        })
        .catch((error) => {
          console.error("Error searching merchant list:", error);
          this.responseMessage = result.error;
          this.isLoading = false;
        });
    },
    selectMerchant(merchant) {
      this.isLoading = true;
      this.$store
        .dispatch("FETCH_MERCHANT_DETAILS_FOR_DEDUCTION", merchant.business_id)
        .then((response) => {
          console.log("merchant details", response.data);
          this.formDetails.merchantDetails.business_id = response.data._id;
          this.formDetails.merchantDetails.business_name = response.data.name;
          this.formDetails.merchantDetails.email = response.data.email;
          this.formDetails.merchantDetails.settlement_type =
            response.data.settlement_type;
          merchant["settlement_type"] = response.data.settlement_type;

          const exists = this.selectedMerchants.some(
            (m) => m.business_name === merchant.business_name
          );
          if (!exists) {
            this.selectedMerchants.push(merchant);
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.error("Error fetching merchant details:", error);
          this.isLoading = false;
        });
    },
    removeMerchant(index) {
      this.selectedMerchants.splice(index, 1);
      this.formDetails.merchantDetails.business_id = "";
      this.formDetails.merchantDetails.business_name = "";
      this.formDetails.merchantDetails.email = "";
      this.formDetails.merchantDetails.settlement_type = "";
      if (this.selectedMerchants.length === 1) {
        const onlyMerchant = this.selectedMerchants[0];
        this.formDetails.merchantDetails.business_id = onlyMerchant.business_id;
        this.formDetails.merchantDetails.business_name =
          onlyMerchant.business_name;
        this.formDetails.merchantDetails.email = onlyMerchant.email;
        this.formDetails.merchantDetails.settlement_type =
          onlyMerchant.settlement_type;
      }
    },
    submitDeduction() {
      this.isLoading = true;
      const process =
        this.sameDeductionMultipleMerchantPayload.length > 1
          ? this.$store.dispatch("ADD_DEDUCTION_BULK", {
              records: this.sameDeductionMultipleMerchantPayload,
            })
          : this.$store.dispatch("ADD_DEDUCTION", this.deductionPayload);

      process
        .then((response) => {
          this.isLoading = false;
          if (response.status) {
            this.$router.push({ name: "AutoDeduction" });
          } else {
            this.responseMessage = `${response.error}. ${response.message}`;
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.error("Error adding deduction:", error);
          this.responseMessage =
            "An error occurred while adding the deduction.";
        });
    },
    async updateDeduction() {
      const response = await this.$store.dispatch("UPDATE_DEDUCTION", {
        id: this.$route.params._id,
        payload: this.updateDeductionPayload,
      });
      if (response.status) {
        this.$router.push({ name: "AutoDeduction" });
      } else {
        this.responseMessage = response.error;
      }
    },
    submitTemplate() {
      this.isLoading = true;
      this.showValidatedTemplate = false;
      this.$store
        .dispatch("TEMPLATE_SUBMIT", { records: this.templateBase64 })
        .then((response) => {
          if (
            response.data.status &&
            (!response.data.failed ||
              Object.keys(response.data.failed).length === 0)
          ) {
            this.csvUploadSuccessful = true;
            this.showValidatedTemplate = false;
          } else if (response.data.failed) {
            this.responseMessage = Object.values(response.data.failed).join(
              `, \n`
            );
            this.csvUploadSuccessful = false;
            this.showValidatedTemplate = false;
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.error("Error submitting template:", error);
          this.responseMessage =
            "An error occurred while submitting the template.";
          this.isLoading = false;
        });
    },
    resetTemplateData() {
      this.showValidatedTemplate = false;
      this.csvUploadSuccessful = false;
      this.templateBase64 = "";
      this.templateData = [];
      this.$refs.fileInput.value = null;
    },
  },
  components: {
    DatePicker,
    Loading,
  },
  created() {
    const d = new Date();
    this.dateData = {
      start_date: new Date(d.setDate(d.getDate() - 1)).toJSON().split("T")[0],
      end_date: new Date().toJSON().split("T")[0],
      startTime: "00:00",
      endTime: this.moment(d).format("HH:mm"),
    };
    console.log("this.$route.params", this.$route.params);

    const requiredEditFiels = [
      this.$route.params.amount,
      this.$route.params.type,
      this.$route.params.startAt,
      this.$route.params.totalAmount,
      this.$route.params.businessEmail,
      this.$route.params.businessId,
      this.$route.params.businessName,
    ];
    console.log("requiredEditsFields", requiredEditFiels);
    // debugger;
    if (
      this.editOrAdd &&
      !requiredEditFiels.every((field) => field || field === 0)
    ) {
      this.$router.push({ name: "AutoDeduction" });
    } else {
      this.formDetails.deductionAmount = this.$route.params.amount;
      this.formDetails.deductionType = this.$route.params.type;
      this.formDetails.deductionFrequency = this.$route.params.frequency;
      this.formDetails.deductionStartDate = moment(
        this.$route.params.startAt
      ).format("YYYY-MM-DD");
      this.formDetails.totalAmount = this.$route.params.totalAmount;
      this.formDetails.loadiskID = this.$route.params.loanDiskId;
      this.formDetails.deductionDay = this.$route.params.dayOfWeek;
      this.formDetails.merchantEmail = this.$route.params.businessEmail;
      this.formDetails.merchantDetails.business_id =
        this.$route.params.businessId;
      this.formDetails.merchantDetails.business_name =
        this.$route.params.businessName;
        this.deductionMethod = this.$route.params.deductionMethod || '';
        this.numberOrPercentage = this.$route.params.numberOrPercentage || false;
    }
  },
  mounted() {
    this.deductionStartDate = [
      moment().startOf("day").toDate(),
      moment().toDate(),
    ];
  },
};
</script>

<style lang="postcss">
.merchant-pill {
  @apply flex bg-white items-center gap-x-1 border-default text-xs w-min border-gray-400 rounded-full px-3 py-2;
}
.row-bg {
  background: #f1f6fc;
}
.row-bg-2 {
  background: #dfe6f1;
}
.row-bg-3 {
  background: #f1f6fc;
}
.form-input {
  border-width: 1px;
  @apply w-full rounded px-2 py-3 text-xs;
}
.mx-datepicker.mx-datepicker {
  @apply w-full;
}
.mx-datepicker.mx-datepicker .mx-input-wrapper input {
  padding: 21px;
}
</style>